export default function TakeSelectPhoto() {
  return null;
}
